import axios from "axios";
// import BASE_URL from "./apiConfig";
import { baseUrl } from "./apiConfig";

export const fetchRecommendation = async (data) => {
  const response = await axios.put(`${baseUrl}/recommend`, {
    recommend: data.recommend,
    relationship: data.relationship,
    reviewEmailId: data.reviewEmailId,
  });
  return response.data.data;
};

export const submitSurveyForm = async (data) => {
  const response = await axios.put(`${baseUrl}/comment`, {
    reviewEmailId: data.reviewEmailId,
    relationship: data.relationship,
    comment: data.comment,
    recommend: data.recommend,
  });
  return response.data;
};

export const reportUnintendedReceipient = async (data) => {
  const response = await axios.put(`${baseUrl}/unintended-recipient`, {
    reviewEmailId: data.reviewEmailId,
    relationship: data.relationship,
    errorType: data.errorType,
    errorReason: data.errorReason,
  });
  return response.data;
};

export const sendCorrectionRequest = async (data) => {
  const reviewEmailId = data.reviewEmailId;
  const response = await axios.post(`${baseUrl}/${reviewEmailId}`, {
    relationship: data.relationship,
  });
  return response.data;
};
